var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ScrollTopComponent',[_c('n-button',{attrs:{"type":"danger","round":""}},[_c('a',{staticClass:"btn btn-light"},[_c('i',{staticClass:"now-ui-icons arrows-1_minimal-up"}),_c('br'),_c('i',{staticClass:"now-ui-icons arrows-1_minimal-up"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }